import { Link } from "react-router-dom";
import { Apple, Play, ArrowRight } from "lucide-react";
import { APP_IS_LIVE, APP_STORE_URL, GOOGLE_PLAY_URL, WAITLIST_HREF } from "../data/appLaunch";

function StoreComingSoonBadge({ store, isDark }) {
    const isApple = store === "apple";
    const Icon = isApple ? Apple : Play;

    return (
        <span
            data-testid={isApple ? "app-store-coming-soon" : "google-play-coming-soon"}
            className={`inline-flex items-center justify-center gap-2.5 h-11 px-5 rounded-full text-sm font-medium border shrink-0 ${
                isDark
                    ? "border-white/15 bg-white/5 text-white/50"
                    : "border-slate-200 bg-slate-50 text-slate-400"
            }`}
            aria-label={`${isApple ? "App Store" : "Google Play"} — Coming Soon`}
        >
            <Icon className={`h-4 w-4 shrink-0 ${!isApple ? "fill-current" : ""}`} />
            <span className="whitespace-nowrap">{isApple ? "App Store" : "Google Play"}</span>
            <span
                className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
                    isDark ? "bg-white/10 text-white/45" : "bg-slate-200 text-slate-500"
                }`}
            >
                Soon
            </span>
        </span>
    );
}

const buttonBase =
    "inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full text-sm sm:text-base font-semibold whitespace-nowrap transition-colors";

export default function AppDownloadButtons({
    variant = "dark",
    showDirectory = false,
    className = "",
}) {
    const isDark = variant === "dark";

    const primaryClass = isDark
        ? "bg-white text-slate-900 hover:bg-white/90 shadow-lg"
        : "bg-slate-950 text-white hover:bg-slate-800 shadow-lg";

    const secondaryClass = isDark
        ? "border border-white/25 bg-white/8 text-white hover:bg-white/12"
        : "border border-slate-200 bg-white text-foreground hover:bg-slate-50";

    if (!APP_IS_LIVE) {
        return (
            <div className={`flex flex-col items-center gap-5 w-full ${className}`}>
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto items-stretch sm:items-center justify-center">
                    <Link
                        to={WAITLIST_HREF}
                        data-testid="waitlist-primary-button"
                        className={`${buttonBase} ${primaryClass} w-full sm:w-auto`}
                    >
                        Join the launch waitlist
                        <ArrowRight className="h-4 w-4 shrink-0" />
                    </Link>
                    {showDirectory && (
                        <Link
                            to="/directory"
                            data-testid="final-cta-directory-button"
                            className={`${buttonBase} ${secondaryClass} w-full sm:w-auto`}
                        >
                            Browse Directory
                        </Link>
                    )}
                </div>
                <div className="flex flex-wrap items-center justify-center gap-2">
                    <StoreComingSoonBadge store="apple" isDark={isDark} />
                    <StoreComingSoonBadge store="google" isDark={isDark} />
                </div>
            </div>
        );
    }

    return (
        <div className={`flex flex-col sm:flex-row gap-3 items-stretch sm:items-center justify-center ${className}`}>
            <a
                href={APP_STORE_URL}
                data-testid="final-cta-start-button"
                className={`${buttonBase} ${primaryClass}`}
            >
                <Apple className="h-4 w-4 shrink-0" />
                App Store
                <ArrowRight className="h-4 w-4 shrink-0" />
            </a>
            <a
                href={GOOGLE_PLAY_URL}
                data-testid="final-cta-demo-button"
                className={`${buttonBase} ${secondaryClass}`}
            >
                <Play className="h-4 w-4 shrink-0 fill-current" />
                Google Play
            </a>
            {showDirectory && (
                <Link
                    to="/directory"
                    data-testid="final-cta-directory-button"
                    className={`${buttonBase} ${secondaryClass}`}
                >
                    Browse Directory
                </Link>
            )}
        </div>
    );
}
